module.exports = __webpack_public_path__ + "img/restore.67660aca.svg";